<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="fm02">
<div class="chapterHead">
<h2 class="chapterTitle"><span class="bold">Kitchen Staples and Recommended Products</span></h2></div>
<div class="chapterBody">
<p class="chapterOpenerText" style="text-indent: 0%"><em class="italic">We’re keeping things simple. Here are some frequently used HG basics to have on hand, plus some specific products we LOVE…</em></p>
<p class="chapterHeadC"><span class="bold">Pantry</span></p>
<p class="paraNoIndent" style="text-indent: 0%">Splenda No Calorie Sweetener (granulated)</p>
<p class="paraNoIndent" style="text-indent: 0%">No-calorie sweetener packets</p>
<p class="extractVerse" style="text-indent: -10pt; margin-left: 2em"><em class="italic">Splenda</em></p>
<p class="paraNoIndent" style="text-indent: 0%">Whole-wheat flour</p>
<p class="paraNoIndent" style="text-indent: 0%">Old-fashioned oats</p>
<p class="paraNoIndent" style="text-indent: 0%">Nonstick cooking spray</p>
<p class="paraNoIndent" style="text-indent: 0%">Low-fat honey graham crackers</p>
<p class="paraNoIndent" style="text-indent: 0%">Rice cakes</p>
<p class="paraNoIndent" style="text-indent: 0%">Mini semi-sweet chocolate chips</p>
<p class="paraNoIndent" style="text-indent: 0%">25-calorie packets diet hot cocoa mix</p>
<div class="extract1">
<p class="extractVerse" style="text-indent: -10pt; margin-left: 2em"><em class="italic">Swiss Miss Diet</em></p></div>
<p class="paraNoIndent" style="text-indent: 0%">Canned black beans</p>
<p class="paraNoIndent" style="text-indent: 0%">Canned crushed tomatoes</p>
<p class="paraNoIndent" style="text-indent: 0%">Canned diced tomatoes</p>
<p class="paraNoIndent" style="text-indent: 0%">Canned pineapple packed in juice (crushed, rings, and tidbits)</p>
<p class="paraNoIndent" style="text-indent: 0%">Canned pure pumpkin</p>
<div class="extract1">
<p class="extractVerse" style="text-indent: -10pt; margin-left: 2em"><em class="italic">Libby’s</em></p>
</div>
<p class="centerImage"><img alt="image" src="Images/20.jpg"/></p>
<p class="chapterHeadC"><span class="bold">Fridge</span></p>
<p class="paraNoIndent" style="text-indent: 0%">Fat-free liquid egg substitute</p>
<div class="extract1">
<p class="extractVerse" style="text-indent: -10pt; margin-left: 2em"><em class="italic">Egg Beaters Original</em></p>
</div>
<p class="paraNoIndent" style="text-indent: 0%">Light whipped butter or light buttery spread</p>
<div class="extract1">
<p class="extractVerse" style="text-indent: -10pt; margin-left: 2em"><em class="italic">Brummel &amp; Brown, Land O’ Lakes Whipped Light Butter</em></p>
</div>
<p class="paraNoIndent" style="text-indent: 0%">Light vanilla soymilk (or another light vanilla milk product)</p>
<div class="extract1">
<p class="extractVerse" style="text-indent: -10pt; margin-left: 2em"><em class="italic">8th Continent Light</em></p>
<p class="extractVerse" style="text-indent: -10pt; margin-left: 2em"><em class="italic">Blue Diamond Unsweetened Vanilla Almond Breeze</em></p>
</div>
<p class="paraNoIndent" style="text-indent: 0%">The Laughing Cow Light Original Swiss cheese wedges</p>
<p class="paraNoIndent" style="text-indent: 0%">Light string cheese</p>
<p class="paraNoIndent" style="text-indent: 0%">Jell-O Sugar Free Pudding Snacks</p>
<p class="paraNoIndent" style="text-indent: 0%">Fat-free yogurt</p>
<div class="extract1">
<p class="extractVerse" style="text-indent: -10pt; margin-left: 2em"><em class="italic">Yoplait Light, Fiber One, Fage Total 0% Greek yogurt</em></p>
</div>
<p class="paraNoIndent" style="text-indent: 0%">Reduced-fat Parmesan-style grated topping</p>
<p class="paraNoIndent" style="text-indent: 0%">Reduced-sodium/lite soy sauce</p>
<p class="paraNoIndent" style="text-indent: 0%">Sugar-free pancake syrup</p>
<div class="extract1">
<p class="extractVerse" style="text-indent: -10pt; margin-left: 2em"><em class="italic">Log Cabin Sugar Free, Mrs. Butterworth’s Sugar Free</em></p>
</div>
<p class="centerImage"><img alt="image" src="Images/21.jpg"/></p>
<p class="paraNoIndent" style="text-indent: 0%">Hellmann’s/Best Foods Dijonnaise</p>
<p class="paraNoIndent" style="text-indent: 0%">Fat-free or nearly fat-free franks</p>
<div class="extract1">
<p class="extractVerse" style="text-indent: -10pt; margin-left: 2em"><em class="italic">Hebrew National 97% Fat Free Beef Franks</em></p>
<p class="extractVerse" style="text-indent: -10pt; margin-left: 2em"><em class="italic">Hoffy Extra Lean Beef Franks</em></p>
</div>
<p class="paraNoIndent" style="text-indent: 0%">Precooked real crumbled bacon</p>
<div class="extract1">
<p class="extractVerse" style="text-indent: -10pt; margin-left: 2em"><em class="italic">Oscar Mayer, Hormel</em></p>
</div>
<p class="paraNoIndent" style="text-indent: 0%">Turkey bacon or center-cut bacon</p>
<p class="paraNoIndent" style="text-indent: 0%">Pillsbury Crescent Recipe Creations Seamless Dough Sheet</p>
<p class="paraNoIndent" style="text-indent: 0%">House Foods Tofu Shirataki Noodle Substitute (stocked with the tofu)</p>
<p class="paraNoIndent" style="text-indent: 0%">Broccoli cole slaw</p>
<div class="extract1">
<p class="extractVerse" style="text-indent: -10pt; margin-left: 2em"><em class="italic">Mann’s Sunny Shores</em></p>
</div>
<p class="chapterHeadC"><span class="bold">Fresh Produce</span></p>
<p class="paraNoIndent" style="text-indent: 0%">Romaine lettuce</p>
<p class="paraNoIndent" style="text-indent: 0%">Onions</p>
<p class="paraNoIndent" style="text-indent: 0%">Bell peppers</p>
<p class="paraNoIndent" style="text-indent: 0%">Cucumbers</p>
<p class="paraNoIndent" style="text-indent: 0%">Tomatoes</p>
<p class="paraNoIndent" style="text-indent: 0%">Fuji apples</p>
<p class="centerImage"><img alt="image" src="Images/22.jpg"/></p>
<p class="chapterHeadC"><span class="bold">Freezer</span></p>
<p class="paraNoIndent" style="text-indent: 0%">Boneless skinless lean chicken breast cutlets Shrimp</p>
<p class="paraNoIndent" style="text-indent: 0%">Fish fillets</p>
<p class="paraNoIndent" style="text-indent: 0%">Boca Original Meatless Burger (Vegan)</p>
<p class="paraNoIndent" style="text-indent: 0%">Ground-beef-style soy crumbles</p>
<div class="extract1">
<p class="extractVerse" style="text-indent: -10pt; margin-left: 2em"><em class="italic">Boca Meatless Ground Crumbles</em></p>
<p class="extractVerse" style="text-indent: -10pt; margin-left: 2em"><em class="italic">Morningstar Farms Meal Starters Grillers Recipe Crumbles</em></p>
</div>
<p class="paraNoIndent" style="text-indent: 0%">Green Giant Just for One Broccoli &amp; Cheese Sauce</p>
<p class="paraNoIndent" style="text-indent: 0%">Assorted vegetables</p>
<p class="paraNoIndent" style="text-indent: 0%">Unsweetened fruit</p>
<p class="paraNoIndent" style="text-indent: 0%">Cool Whip Free</p>
<p class="chapterHeadC"><span class="bold">Breadbox</span></p>
<p class="paraNoIndent" style="text-indent: 0%"><em class="italic">Does anyone HAVE an actual breadbox anymore?</em></p>
<p class="spaceBreak"> </p>
<p class="paraNoIndent" style="text-indent: 0%">Light bread (40 to 45 calories and at least 2 grams of fiber per slice)</p>
<div class="extract1">
<p class="extractVerse" style="text-indent: -10pt; margin-left: 2em"><em class="italic">Sara Lee Delightful, Nature’s Own Light</em></p>
</div>
<p class="paraNoIndent" style="text-indent: 0%">Light English muffins (high in fiber with about 100 calories each)</p>
<p class="paraNoIndent" style="text-indent: 0%">Burrito-size tortillas with about 110 calories (high in fiber, low in fat)</p>
<div class="extract1">
<p class="extractVerse" style="text-indent: -10pt; margin-left: 2em"><em class="italic">La Tortilla Factory Smart &amp; Delicious Low Carb High Fiber</em></p>
<p class="extractVerse" style="text-indent: -10pt; margin-left: 2em"><em class="italic">Mission Carb Balance</em></p>
<p class="extractVerse" style="text-indent: -10pt; margin-left: 2em"><em class="italic">Tumaro’s 8</em>” <em class="italic">Low in Carbs or Healthy Flour Tortillas</em></p>
<p class="extractVerse" style="text-indent: -10pt; margin-left: 2em"><em class="italic">Flatout Light Wraps</em></p>
</div>
<p class="centerImage"><img alt="image" src="Images/23.jpg"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// hungrygirl123_fm02.vue?a1282a58